export default "__VITE_ASSET__Cok401dE__"